export interface CurrentFallTerminalVelocityInput {
  enabled: boolean;
  isCurrent: boolean;
  dropped: boolean;
  placed: boolean;
  hasEverContactedStack: boolean;
  dynamic: boolean;
  gravityY: number;
  velocityY: number;
  terminalSpeed: number;
}

export function gravityDirectionVelocityY(input: CurrentFallTerminalVelocityInput): number {
  if (!input.enabled
    || !input.isCurrent
    || !input.dropped
    || input.placed
    || input.hasEverContactedStack
    || !input.dynamic
    || !Number.isFinite(input.velocityY)
    || !Number.isFinite(input.terminalSpeed)
    || input.terminalSpeed <= 0) {
    return input.velocityY;
  }
  if (input.gravityY < 0) return Math.max(input.velocityY, -input.terminalSpeed);
  if (input.gravityY > 0) return Math.min(input.velocityY, input.terminalSpeed);
  return input.velocityY;
}
